import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './services/AuthContext';
import { NotesProvider } from "./services/NotesContext";
import { BesoinsProvider } from "./services/BesoinsContext";

import AppWrapper from './components/AppWrapper';
import './css/App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const App = () => (
  <Router>
    <AuthProvider>
      <NotesProvider>
        <BesoinsProvider>
          <AppWrapper />
        </BesoinsProvider>
      </NotesProvider>    
    </AuthProvider>
  </Router>
);

export default App;
